let price = 150

export default price